<template>
  <div class="filters-container">
    <div class="filter-type-box">
      <div class="title">
        {{ texts.title }}
      </div>
      <div class="description">
        {{ texts.description }}
      </div>
      <div class="radio-buttons">
        <div
          class="radio-container"
          v-for="option in filterOptions"
          :key="option"
        >
          <Radio
            class="radio-button"
            :value="option"
            :name="option"
            :selectedValue="filterType"
            @input="$emit('selectFilterType', $event)"
          >
            {{option}}
          </Radio>
        </div>
      </div>
    </div>
    <BasicFilters
      v-if="isBasicSelected"
      :availableInsightsFilters="availableInsightsFilters"
      :availableShopperIntelligenceFilters="availableShopperIntelligenceFilters"
      :selectedFilters="selectedBasicFilters"
      :dateRange="dateRange"
      :brandIds="brandIds"
      :portfolioBrands="portfolioBrands"
      @updateFilters="$emit('updateBasicFilters', $event)"
    />
    <AdvancedFilters
      v-else
      :availableInsightsFilters="availableInsightsFilters"
      :availableShopperIntelligenceFilters="availableShopperIntelligenceFilters"
      :selectedFiltersGroups="selectedAdvancedFilters"
      :dateRange="dateRange"
      :brandIds="brandIds"
      @updateAdvancedFilters="$emit('updateAdvancedFilters', $event)"
    />
  </div>
</template>
<script>
import { Radio } from '@mikmak/components';
import BasicFilters from './Basic/Filters';
import AdvancedFilters from './Advanced/Filters';

export default {
  props: {
    filterType: {
      type: String,
      required: true,
    },
    availableInsightsFilters: {
      type: Array,
      required: true,
    },
    availableShopperIntelligenceFilters: {
      type: Array,
      required: true,
    },
    selectedBasicFilters: {
      type: Array,
      required: true,
    },
    selectedAdvancedFilters: {
      type: Array,
      required: true,
    },
    dateRange: {
      type: Object,
    },
    brandIds: {
      type: Array,
    },
    portfolioBrands: {
      type: Array,
    },
  },
  data() {
    return {
      texts: {
        title: 'Select a filter type',
        description: 'Basic filters cannot be combined with advanced filters',
      },
      filterOptions: ['Basic', 'Advanced'],
    };
  },
  computed: {
    isBasicSelected() {
      return this.filterType === 'Basic';
    },
  },
  components: {
    Radio,
    BasicFilters,
    AdvancedFilters,
  },
};
</script>
<style lang="scss" scoped>
.filter-type-box {
  padding: 12px;
  width: calc(100% - 24px);
  top: 100px;
  margin-bottom: 32px;
  background: #F0F3FE;
  border-radius: 4px;
}
.title {
  font-weight: bold;
  font-size: 18px;
  line-height: 140%;
  color: #223448;
}
.description {
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #778699;
}
.radio-buttons {
  display: flex;
  flex-direction: row;
  padding-top: 10px;
}
.radio-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.radio-button {
  cursor: pointer;
  font-weight: normal;
  font-size: 16px;
  line-height: 100%;
  color: #778699;
  padding-right: 20px;
}
</style>
